<template>
  <div></div>
</template>
<script>
export default {
  created() {
    let back_url = this.getQueryString('back_url');
    let token = localStorage.getItem('ms_token')
    if(token){
        window.location.href = back_url;
    }else{
        this.$router.push({
            path:'/login',
            query:{
                back_url:back_url
            }
        })
    }
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    UpdateUrlParam(url, name, val) {
        url = decodeURIComponent(url);
        // 如果 url中包含这个参数 则修改
        if (url.indexOf(name+'=') > 0) {
            var v = this.getQueryString(name);
            if (v != null) {
                // 是否包含参数
                url = url.replace(name + '=' + v, name + '=' + val);
            }
            else {
                url = url.replace(name + '=', name + '=' + val);
            }

        } // 不包含这个参数 则添加
        else {
            if (url.indexOf("?") > 0) {
                url = url + "&" + name + "=" + val;
            }
            else {
                url = url + "?" + name + "=" + val;
            }
        }
        return url;
    }
  }
};
</script>
